import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'reset_password';
export const route = 'reset_password/[[...slug]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "resetpassword" */
'../../components/ResetPassword')));